import { gql } from '@apollo/client'
import { getWebClient } from '@/services/ApolloClient'
import { GetContinueWatchingQuery } from '@/types/codegen-federation'
import { isDefined } from '@/utils/types'

export const GET_CONTINUE_WATCHING_DATA = gql`
  query getContinueWatching {
    projects {
      name
      slug
      logoCloudinaryPath
      projectType
      continueWatching {
        name
        subtitle
        id
        guid
        duration
        episodeNumber
        projectSlug
        posterLandscapeCloudinaryPath
        prereleaseAvailableFor
        userHasEarlyAccess
        season {
          id
          seasonNumber
        }
        watchPosition {
          id
          position
          updatedAt
        }
        earlyAccessDate
        publiclyAvailableDate
        isAngelGuildOnly
        prereleaseAvailableFor
        isTrailer
        guildAvailableDate
        publiclyAvailableDate
        earlyAccessDate
        unavailableReason
      }
    }
  }
`

export type ContinueWatchingProject = NonNullable<
  NonNullable<NonNullable<GetContinueWatchingQuery>['projects']>[number]
>

export type ContinueWatchingEpisode = NonNullable<
  NonNullable<NonNullable<NonNullable<GetContinueWatchingQuery>['projects']>[number]>['continueWatching']
>

export async function getContinueWatching({ locale }: { locale: string }): Promise<ContinueWatchingProject[]> {
  const response = await getWebClient({ locale }).query<GetContinueWatchingQuery>({
    query: GET_CONTINUE_WATCHING_DATA,
    errorPolicy: 'all',
  })
  return response.data.projects?.filter(isDefined) ?? []
}

export function mapContinueWatchingProjectsToContentLinks(
  projects: ContinueWatchingProject[],
): ContinueWatchingProject[] {
  return projects.filter((project) => isDefined(project.continueWatching?.watchPosition))
}

export function isContinueWatchingProject(continueWatching: unknown): continueWatching is ContinueWatchingProject {
  const continueWatchingProject = continueWatching as ContinueWatchingProject

  return (
    continueWatchingProject &&
    Boolean(continueWatchingProject.slug) &&
    Boolean(continueWatchingProject.continueWatching)
  )
}

export function isContinueWatchingEpisode(continueWatching: unknown): continueWatching is ContinueWatchingEpisode {
  const continueWatchingEpisode = continueWatching as ContinueWatchingEpisode

  return (
    continueWatchingEpisode && Boolean(continueWatchingEpisode.guid) && Boolean(continueWatchingEpisode?.watchPosition)
  )
}
